import React, {useEffect} from 'react';
import styles from './AuthorPage.module.css';
import {useNavigate, useParams} from "react-router-dom";
import AuthorHeader from '../components/AuthorHeader/AuthorHeader';
import StatsGrid from '../components/StatsGrid/StatsGrid';
import TopicsTagsSection from '../components/TopicsTagsSection/TopicsTagsSection';
import useGetUser from "../hooks/useGetUser";
import useGetAuthorStats from "../hooks/useGetAuthorStats";


const AuthorPage = () => {
    const {id} = useParams<{ id: string }>();
    const userId = id ? parseInt(id) : -1;
    const navigate = useNavigate();
    const {getUser, data, isLoading, error} = useGetUser();
    const {getAuthorStats, data: autorState} = useGetAuthorStats();

    useEffect(() => {
        if (userId > 0) {
            getUser(userId);
            getAuthorStats(userId);
        }
    }, [getUser, userId]);

    if (isLoading) {
        return <div className={styles.authorPage}>Загрузка...</div>;
    }

    if (error) {
        return <div className={styles.authorPage}>Ошибка: {error}</div>;
    }

    if (!data) {
        return <div className={styles.authorPage}>Нет данных</div>;
    }

    // Данные автора
    const authorData = {
        username: data.username,
        email: data.email,
        registrationDate: data.created_at,
        lastActivity: data.last_login,
        avatar: data.avatar_url || "https://i.pinimg.com/736x/19/9b/9c/199b9cf3b7d032b39fc5c7e920fd625c.jpg",
        totalPosts: autorState?.total_authors || 0,
        authorPosts: autorState?.author_posts || 0,
        topics: autorState?.categories || [],
        tags: autorState?.tags || [],
        rating: 4.8,
        rank: 5,
        totalAuthors: autorState?.total_authors || 1,
        bio: data.bio || "Нет данных"
    };

    // Статистика для сетки
    const statsData = [
        {value: authorData.authorPosts, label: "Всего постов", description: "И это только начало! 🚀"},
        {value: authorData.topics.length, label: "Темы", description: "Разносторонний как швейцарский нож 🔪"},
        {value: authorData.tags.length, label: "Теги", description: "Мастер хэштегов #️⃣"},
        {value: authorData.rating, label: "Рейтинг", description: "Почти идеально! 🌟"}
    ];

    return (
        <div className={styles.authorPage}>
            <div className={styles.authorContainer}>
                <button onClick={() => navigate(-1)} className={styles.backButton}>
                    &larr; Назад к статьям
                </button>

                <AuthorHeader
                    username={authorData.username}
                    avatar={authorData.avatar}
                    rating={authorData.rating}
                    bio={authorData.bio}
                    email={authorData.email}
                    registrationDate={authorData.registrationDate}
                    lastActivity={authorData.lastActivity}
                />

                <StatsGrid stats={statsData}/>

                <h2 className={styles.sectionTitle}>Активность по темам и тегам 📊</h2>
                <TopicsTagsSection topics={authorData.topics} tags={authorData.tags}/>

                <h2 className={styles.sectionTitle}>Способы связи 📞</h2>
                <div className={styles.contactMethods}>
                    <div className={styles.contactInfo}>
                        <p>Хотите предложить сотрудничество или просто поболтать? 😊</p>
                    </div>

                    <div className={styles.contactButtons}>
                        <a
                            href={`mailto:${authorData.email}`}
                            className={styles.contactButton}
                            title="Написать на почту"
                        >
                            <span className={styles.contactIcon}>📧</span>
                            <span>Email</span>
                        </a>

                        <button
                            className={styles.contactButton}
                            onClick={() => alert('Телеграм: @vivera_blog (но это не точно)')}
                            title="Написать в Telegram"
                        >
                            <span className={styles.contactIcon}>📱</span>
                            <span>Telegram</span>
                        </button>

                        <button
                            className={styles.contactButton}
                            onClick={() => alert('Извините, я занят(а) написанием следующего гениального поста!')}
                            title="Написать в WhatsApp"
                        >
                            <span className={styles.contactIcon}>💬</span>
                            <span>WhatsApp</span>
                        </button>
                    </div>
                </div>

                <h2 className={styles.sectionTitle}>Рейтинг и статистика 🏆</h2>
                <div className={styles.ratingSection}>
                    <div className={styles.rankInfo}>
                        <p>
                            <strong>Место в рейтинге авторов:</strong> {authorData.totalAuthors} из {authorData.rank}
                        </p>
                        <p className={styles.rankComment}>
                            {authorData.rank <= 5
                                ? "Входит в топ авторов! 🎉"
                                : authorData.rank <= 20
                                    ? "Отличный результат! 👍"
                                    : "Хорошее начало! 🚀"
                            }
                        </p>
                    </div>

                    <div className={styles.progressContainer}>
                        <div className={styles.progressBar}>
                            <div
                                className={styles.progressFill}
                                style={{width: `${(1 - (authorData.rank - 1) / authorData.totalAuthors) * 100}%`}}
                            ></div>
                        </div>
                        <div className={styles.progressLabels}>
                            <span>1 место</span>
                            <span>{authorData.totalAuthors} место</span>
                        </div>
                    </div>
                </div>

                <div className={styles.funFact}>
                    <h3>Знаете ли вы? 🤓</h3>
                    <p>
                        Этот автор тратит примерно {Math.round(authorData.totalPosts * 4.2)} часов в месяц на написание
                        постов.
                        Это примерно {Math.round((authorData.totalPosts * 4.2) / 30)} часов в день!
                        Видимо, кофеварка работает без остановки ☕🔥
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AuthorPage;